import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { isValidElement } from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './List.styles.js';

var defaultProps = {
  isOrdered: false,
  orderedMode: "numeric",
  textSize: "copy-text",
  iconColor: "default"
};
var ListPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      children = props.children,
      className = props.className,
      noMargin = props.noMargin,
      isOrdered = props.isOrdered,
      orderedMode = props.orderedMode,
      icon = props.icon,
      iconColor = props.iconColor,
      textSize = props.textSize;
  var Component = isOrdered ? "ol" : "ul";
  return /*#__PURE__*/React.createElement(Component, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__ordered-").concat(orderedMode), isOrdered), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__unordered-dash"), !isOrdered && !icon), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__unordered-icon"), !isOrdered && icon), _defineProperty(_cleanupClassObject, "".concat(hostClass, "-").concat(textSize), true), _cleanupClassObject))
  }, React.Children.map(children, function (child) {
    var _a;

    return icon && /*#__PURE__*/isValidElement(child) && !((_a = child.props) === null || _a === void 0 ? void 0 : _a.icon) ? /*#__PURE__*/React.cloneElement(child, {
      icon: icon,
      iconColor: iconColor
    }) : child;
  }));
}, defaultProps);

export { ListPresentation, defaultProps };
